function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 86,
  r: 50,
  fill: "#0BE1BB"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95.0324 71.5077C94.4987 72.2076 94.6333 73.2077 95.3332 73.7415C99.1334 76.6397 101.406 81.1299 101.406 86C101.406 93.939 95.4013 100.475 87.6858 101.315L89.123 99.877C89.7454 99.2546 89.7454 98.2454 89.123 97.623C88.5572 97.0572 87.6718 97.0058 87.0479 97.4687L86.8691 97.623L82.6191 101.873C82.0533 102.439 82.0019 103.324 82.4648 103.948L82.6191 104.127L86.8691 108.377C87.4915 108.999 88.5007 108.999 89.123 108.377C89.6889 107.811 89.7403 106.926 89.2774 106.302L89.123 106.123L87.5288 104.532C97.0827 103.754 104.594 95.7543 104.594 86C104.594 80.1249 101.849 74.7018 97.2662 71.2069C96.5663 70.6732 95.5662 70.8078 95.0324 71.5077ZM82.877 63.623C82.2546 64.2454 82.2546 65.2546 82.877 65.877L84.4691 67.4684C74.9162 68.2469 67.4062 76.2464 67.4062 86C67.4062 91.6195 69.9164 96.832 74.1655 100.342C74.8441 100.902 75.8486 100.807 76.4092 100.128C76.9698 99.4495 76.8741 98.4449 76.1955 97.8844C72.6719 94.9737 70.5938 90.6584 70.5938 86C70.5938 78.0618 76.5975 71.5258 84.3121 70.6852L82.877 72.123C82.2546 72.7454 82.2546 73.7546 82.877 74.377C83.4993 74.9994 84.5085 74.9994 85.1309 74.377L89.3809 70.127C90.0033 69.5046 90.0033 68.4954 89.3809 67.873L85.1309 63.623C84.5085 63.0007 83.4993 63.0007 82.877 63.623Z",
  fill: "white"
});

function SvgPendingStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingStatus);
export default __webpack_public_path__ + "static/media/pending_status.b92804ac.svg";
export { ForwardRef as ReactComponent };